import React, { useEffect, useRef } from 'react';

function CursorRing() {
  const ringRef = useRef(null);
  const dotRef = useRef(null);
  const stateRef = useRef({ rx: 0, ry: 0, dx: 0, dy: 0, tx: 0, ty: 0 });
  const rafRef = useRef(null);

  useEffect(() => {
    if (window.matchMedia('(hover: none)').matches) return undefined;

    const onMove = (event) => {
      stateRef.current.tx = event.clientX;
      stateRef.current.ty = event.clientY;
      if (!rafRef.current) rafRef.current = requestAnimationFrame(tick);
    };

    const tick = () => {
      const s = stateRef.current;
      s.rx += (s.tx - s.rx) * 0.18;
      s.ry += (s.ty - s.ry) * 0.18;
      s.dx += (s.tx - s.dx) * 0.45;
      s.dy += (s.ty - s.dy) * 0.45;

      if (ringRef.current) {
        ringRef.current.style.transform = `translate3d(${s.rx - 17}px, ${s.ry - 17}px, 0)`;
      }
      if (dotRef.current) {
        dotRef.current.style.transform = `translate3d(${s.dx - 3}px, ${s.dy - 3}px, 0)`;
      }

      const dist = Math.hypot(s.tx - s.rx, s.ty - s.ry) + Math.hypot(s.tx - s.dx, s.ty - s.dy);
      if (dist > 0.2) {
        rafRef.current = requestAnimationFrame(tick);
      } else {
        rafRef.current = null;
      }
    };

    const hoverTargets = 'a, button, [data-cursor="hover"], input, textarea, select, label';

    const onEnter = (event) => {
      if (event.target instanceof Element && event.target.closest(hoverTargets) && ringRef.current) {
        ringRef.current.classList.add('is-hover');
      }
    };
    const onLeave = (event) => {
      if (event.target instanceof Element && event.target.closest(hoverTargets) && ringRef.current) {
        ringRef.current.classList.remove('is-hover');
      }
    };

    window.addEventListener('mousemove', onMove);
    document.addEventListener('mouseover', onEnter);
    document.addEventListener('mouseout', onLeave);

    return () => {
      window.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseover', onEnter);
      document.removeEventListener('mouseout', onLeave);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, []);

  return (
    <>
      <div ref={ringRef} className="cursor-ring" aria-hidden="true" />
      <div ref={dotRef} className="cursor-dot" aria-hidden="true" />
    </>
  );
}

export default CursorRing;
